import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export interface AIAnnotationWatchmenPluginState {
	isWatching: boolean;
	watchFrom?: number;
	watchTo?: number;
	startingAnnotationIds?: string[];
}

export const aiAnnotationWatchmenPluginKey = new PluginKey<AIAnnotationWatchmenPluginState>(
	'aiAnnotationWatchmen',
);
